import { useState } from "react";
import { Navbar } from "./components/Navbar";
import { Hero } from "./components/Hero";
import { HeroVideo } from "./components/HeroVideo";
import { ProductCategories } from "./components/ProductCategories";
import { ProductSwiper } from "./components/ProductSwiper";
import { WhyChooseUs } from "./components/WhyChooseUs";
import { SafetySection } from "./components/SafetySection";
import { ContactPage } from "./components/ContactPage";
import { AboutPage } from "./components/AboutPage";
import { Footer } from "./components/Footer";
import { ProductPage } from "./components/ProductPage";
import { CategoryPage } from "./components/CategoryPage";
import { GalleryPage } from "./components/GalleryPage";
import "./index.css";
import { VaigaiCertificationDisplay } from "./components/VaigaiCertificationDisplay";
import { WhatsAppButton } from "./components/WhatsAppButton";

export default function App() {
  const [currentPage, setCurrentPage] = useState("home");
  const [selectedCategory, setSelectedCategory] = useState<string>("");
  const [product, setproduct] = useState<string>("");
  const [previousPage, setPreviousPage] = useState<string>("home"); // New state to track previous page

  // Simple navigation handler
  const handleNavigation = (page: string) => {
    setCurrentPage(page);
  };
console.log(product);

  // Category navigation handler
  const handleCategoryClick = (categoryId: string) => {
    setSelectedCategory(categoryId);
    setCurrentPage("category");
  };
  const handleproductClick = (productId: string) => {
    sessionStorage.setItem("productId", productId);
    setproduct(productId);
    setPreviousPage(currentPage); // Set previous page before navigating
    setCurrentPage("product-page");
  };
  // Back to home handler
  const handleBackToHome = () => {
    setCurrentPage("home");
    setSelectedCategory("");
  };
  const handleBackToCategory = () => {
    setCurrentPage("category");
    // setSelectedCategory("");
  };

  // Listen for hash changes to enable navigation
  if (typeof window !== "undefined") {
    window.addEventListener("hashchange", () => {
      const hash = window.location.hash.substring(1);
      if (hash === "product-page" || hash === "products") {
        setPreviousPage(currentPage); // Set previous page before navigating via hash
        setCurrentPage("product-page");
      } else if (hash === "gallery") {
        setCurrentPage("gallery");
      } else if (hash === "contact") {
        setCurrentPage("contact");
      } else if (hash === "about") {
        setCurrentPage("about");
      } else {
        setCurrentPage("home");
      }
    });
  }

  return (
    <div className="min-h-screen bg-logo-dark">
      <Navbar onNavigate={handleNavigation} currentPage={currentPage} />
      <main>
        {currentPage === "category" ? (
          <CategoryPage
            category={selectedCategory}
            onBack={handleBackToHome}
            handleproductClick={handleproductClick}
          />
        ) : currentPage === "gallery" ? (
          <GalleryPage onBack={handleBackToHome} />
        ) : currentPage === "product-page" ? (
          <ProductPage
            onBack={previousPage === "category" ? handleBackToCategory : handleBackToHome}
          />
        ) : currentPage === "contact" ? (
          <ContactPage />
        ) : currentPage === "about" ? (
          <AboutPage />
        ) : (
          <>
            <HeroVideo />

            <Hero />
            <ProductCategories onCategoryClick={handleCategoryClick} />
            <ProductSwiper handleproductClick={handleproductClick} />
            {/* <FeaturedProducts /> */}
            <WhyChooseUs />
            <VaigaiCertificationDisplay/>
            <SafetySection />
          </>
        )}
      </main>
      {(currentPage === "home" || currentPage === "contact") && <Footer />}
      <WhatsAppButton />
    </div>
  );
}
